export const environment = {
  production: false,
  linearStepper: true,
  assetsUrl: 'https://espenrollmentq-h4fzdgdvf6abekbr.z01.azurefd.net',
  baseHref: 'https://espenrollmentq-h4fzdgdvf6abekbr.z01.azurefd.net/',
  environmentLink: 'https://customerq.pwc.ca',
  bffURL:
    'https://apiq-ext.pwc.ca/pwc-dt-qa-dmz/customer-services/custsvc-espenrollment-bff/v1/api',
  awsURL:
    'https://apiq-ext.pwc.ca/pwc-dt-qa-dmz/customer-services/custsvc-aws-file-upload/v1/api',
  apiClientId: '1b80e2650cd48888ff85eb1cee71d1bd',
  apiBffClientId: '405809ee79b1ac437c1eaebf048e2955',
  surveyURL: 'https://pwutc.qualtrics.com/jfe/form/SV_bOvs52JyhcGHglU',
};
